
import React from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ContextualMenuItemType } from 'office-ui-fabric-react/lib/ContextualMenu';

import { setBaseLayerVisibility, setOverLayerVisibility } from './setVisibility';

function isLayerVisible(layer, map) {
    let isVisible = true;
    if (layer.maxResolution) {
        isVisible = isVisible && (map.resolution <= layer.maxResolution);
    }
    if (layer.minResolution) {
        isVisible = isVisible && (map.resolution >= layer.minResolution);
    }
    return isVisible;
}

function getMenuProps(layers, groups, map, onMenuItemClick) {
    let items = [];
    groups.forEach(group => {
        let groupItems = [];
        group.layers.forEach(layerId => {
            layers.forEach(layer => {
                if (layer.id === layerId) {
                    groupItems.push({
                        key: layer.id,
                        text: layer.title,
                        layer: layer,
                        disabled: !isLayerVisible(layer, map),
                        onClick: onMenuItemClick,
                        iconProps: {
                            iconName: layer.visible ? 'CheckMark' : ''
                        },
                    });
                }
            })
        });

        items.push({
            key: group.id,
            itemType: ContextualMenuItemType.Section,
            sectionProps: {
                title: group.title,
                items: groupItems
            }
        });
    });
    return items;
}

const LayerSwitcher = (props) => {

    let onMenuItemClick = (event, item) => {
        if (item.layer.base) {
            setBaseLayerVisibility(props.layers, item.layer, props.moduleActions.setLayerVisibility);
        } else {
            setOverLayerVisibility(props.layers, item.layer, props.moduleActions.setLayerVisibility);
        };
    };

    return (
        <DefaultButton
            text="Seznam vrstev"
            menuProps={{
                items: getMenuProps(props.layers, props.groups, props.map, onMenuItemClick)
            }}
            iconProps={{iconName: 'MapLayers'}}
            allowDisabledFocus
        />
    );
};

export default LayerSwitcher;
